import { render, staticRenderFns } from "./WizardListing.vue?vue&type=template&id=96628da2&scoped=true"
import script from "./WizardListing.vue?vue&type=script&lang=js"
export * from "./WizardListing.vue?vue&type=script&lang=js"
import style0 from "./WizardListing.vue?vue&type=style&index=0&id=96628da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96628da2",
  null
  
)

export default component.exports